import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../utils/supabaseClient';
import styles from '../styles/auth-callback.module.css';
import { toast } from 'sonner';

const AuthCallback = () => {
  const navigate = useNavigate();
  const [error, setError] = useState(null);

  useEffect(() => {
    const handleAuthCallback = async () => {
      try {
        // Get the session from URL
        const { data, error } = await supabase.auth.getSession();
        
        if (error) {
          throw error;
        }

        if (data?.session) {
          // Successfully authenticated
          const userId = data.session.user.id;
          
          // AUTO-GRANT FREE SUBSCRIPTION if in free access mode and user is new
          const isFreeAccessMode = process.env.REACT_APP_FREE_ACCESS_MODE === 'true';
          if (isFreeAccessMode && userId) {
            try {
              // Check if user already has a subscription
              const { data: existingSub } = await supabase
                .from('subscriptions')
                .select('*')
                .eq('user_id', userId)
                .single();
              
              // If no subscription exists, create a free one
              if (!existingSub) {
                console.log('Free access mode enabled - creating free subscription for OAuth user:', userId);
                const { error: subError } = await supabase.from('subscriptions').insert({
                  user_id: userId,
                  status: 'active',
                });
                
                if (subError) {
                  console.error('Error creating free subscription:', subError);
                } else {
                  console.log('Free subscription created successfully for OAuth user');
                }
              }
            } catch (subError) {
              console.error('Error in free subscription creation:', subError);
              // Don't block authentication if subscription creation fails
            }
          }
          
          toast.success('Successfully signed in!');
          
          // Redirect to home or the intended destination
          setTimeout(() => {
            navigate('/home');
          }, 1000);
        } else {
          // No session found, something went wrong
          setError('Authentication failed. Please try again.');
          
          // Redirect back to auth page after a delay
          setTimeout(() => {
            navigate('/auth');
          }, 3000);
        }
      } catch (err) {
        console.error('Auth callback error:', err);
        setError(err.message || 'Authentication failed. Please try again.');
        
        // Redirect back to auth page after a delay
        setTimeout(() => {
          navigate('/auth');
        }, 3000);
      }
    };

    handleAuthCallback();
  }, [navigate]);

  return (
    <div className={styles.callbackContainer} >
      <div className={styles.callbackCard}>
        {error ? (
          <>
            <div className={styles.errorIcon}>
              <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="12" r="10"></circle>
                <line x1="15" y1="9" x2="9" y2="15"></line>
                <line x1="9" y1="9" x2="15" y2="15"></line>
              </svg>
            </div>
            <h1 className={styles.callbackTitle}>Authentication Failed</h1>
            <p className={styles.callbackMessage}>{error}</p>
            <p className={styles.redirectMessage}>Redirecting back to login page...</p>
          </>
        ) : (
          <>
            <div className={styles.loadingSpinner}></div>
            <h1 className={styles.callbackTitle}>Completing Sign In</h1>
            <p className={styles.callbackMessage}>Please wait while we authenticate your account...</p>
          </>
        )}
      </div>
    </div>
  );
};

export default AuthCallback;
